/**
 * zmanDefinitions.js — הגדרות מרכזיות של זמנים הלכתיים
 *
 * key      — המפתח ב-Redux / fetchZmanimForDate
 * label    — שם עברי לתצוגה
 * method   — שיטת חישוב (תקציר)
 * tooltip  — הסבר הלכתי מלא
 * primary  — true = מוצג bold (זמן עיקרי)
 * group    — קבוצה לתצוגה בדרופדאון
 * showOnlyWhen — { hebrewDay, hebrewMonth } — הקבוצה תוצג רק בתאריך זה
 */
export const ZMAN_DEFINITIONS = [
  // ─── בוקר ──────────────────────────────────────────────────────────────────
  {
    key: 'alotHaShachar',
    label: 'עלות השחר',
    method: '16.1° מתחת לאופק לפני נץ',
    tooltip: 'תחילת היממה ההלכתית. מחושב כ-16.1° מתחת לאופק לפני הנץ לפי שיטת הגר"א. מותר להניח תפילין מזמן זה.',
    primary: false,
    group: 'בוקר',
  },
  {
    key: 'netzHachama',
    label: 'נץ החמה',
    method: 'זריחת השמש',
    tooltip: 'זמן זריחת השמש — תחילת זמן תפילת שחרית לדעה הראשונה (וותיקין). מחושב בדיוק שניות לפי קואורדינטות.',
    primary: true,
    group: 'בוקר',
  },
  // ─── סוף זמן שמע ──────────────────────────────────────────────────────────
  {
    key: 'sofZmanShma',
    label: 'סוף זמן שמע — גר"א',
    method: 'גר"א — שעה 3 מנץ לשקיעה',
    tooltip: 'סוף זמן קריאת שמע לשיטת הגר"א — שליש היום (= שעה 3 מתוך 12) מנץ החמה עד שקיעה. שעה הלכתית = 1/12 מהיום.',
    primary: true,
    group: 'סוף זמן שמע',
  },
  {
    key: 'sofZmanShmaMGA',
    label: 'סוף זמן שמע — מג"א (90 במע׳)',
    method: 'מג"א — שעה 3 מעלות 19.8° לצאת 19.8° (מחמיר)',
    tooltip: 'סוף זמן קריאת שמע לשיטת המג"א — שליש היום מעלות השחר 19.8° עד צאת כוכבים 19.8°. 19.8° מחמיר יותר מ-16.1° כי עלות השחר מוקדמת יותר → השעה ההלכתית מתחילה מוקדם יותר → סוף זמן שמע מוקדם יותר.',
    primary: true,
    group: 'סוף זמן שמע',
  },
  {
    key: 'sofZmanShmaMGA16Point1',
    label: 'סוף זמן שמע — מג"א (72 במע׳)',
    method: 'מג"א — שעה 3 מעלות 16.1° לצאת 16.1° (מקיל)',
    tooltip: 'סוף זמן קריאת שמע לשיטת המג"א לפי חישוב 16.1° — שליש היום מעלות השחר 16.1° עד צאת כוכבים 16.1°. קל יותר מ-19.8° — זמן שמע מאוחר יותר.',
    primary: false,
    group: 'סוף זמן שמע',
  },
  // ─── סוף זמן תפילה ────────────────────────────────────────────────────────
  {
    key: 'sofZmanTfilla',
    label: 'סוף זמן תפילה — גר"א',
    method: 'גר"א — שעה 4 מנץ לשקיעה',
    tooltip: 'סוף זמן תפילת שחרית לשיטת הגר"א — שעה 4 מתוך 12 שעות הלכתיות מנץ החמה. לאחר זמן זה התפלל בדיעבד ללא תפילת שמונה עשרה.',
    primary: true,
    group: 'סוף זמן תפילה',
  },
  {
    key: 'sofZmanTfillaMGA',
    label: 'סוף זמן תפילה — מג"א (90 במע׳)',
    method: 'מג"א — שעה 4 מעלות 19.8° לצאת 19.8° (מחמיר)',
    tooltip: 'סוף זמן תפילת שחרית לשיטת המג"א לפי חישוב 19.8° — שעה 4 מעלות השחר 19.8° עד צאת כוכבים 19.8°. מחמיר יותר מ-16.1° — זמן תפילה מוקדם יותר.',
    primary: true,
    group: 'סוף זמן תפילה',
  },
  {
    key: 'sofZmanTfillaMGA16Point1',
    label: 'סוף זמן תפילה — מג"א (72 במע׳)',
    method: 'מג"א — שעה 4 מעלות 16.1° לצאת 16.1° (מקיל)',
    tooltip: 'סוף זמן תפילת שחרית לשיטת המג"א לפי חישוב 16.1° — שעה 4 מעלות השחר 16.1° עד צאת כוכבים 16.1°. קל יותר מ-19.8° — זמן תפילה מאוחר יותר.',
    primary: false,
    group: 'סוף זמן תפילה',
  },
  // ─── אמצע היום ────────────────────────────────────────────────────────────
  {
    key: 'chatzot',
    label: 'חצות היום',
    method: 'אמצע היום ההלכתי',
    tooltip: 'חצות היום — בדיוק אמצע בין הנץ לשקיעה. זמן שחיטת קרבן הפסח. לאחר חצות אסור לאכול חמץ ומתחיל זמן מנחה גדולה.',
    primary: true,
    group: 'אמצע היום',
  },
  {
    key: 'minchaGedola',
    label: 'מנחה גדולה',
    method: 'חצות + חצי שעה הלכתית',
    tooltip: 'זמן מנחה גדולה — חצי שעה הלכתית אחרי חצות. תחילת זמן מנחה לכתחילה לפי הגמרא.',
    primary: false,
    group: 'אמצע היום',
  },
  {
    key: 'minchaKetana',
    label: 'מנחה קטנה',
    method: 'שעה 9.5 הלכתית',
    tooltip: 'זמן מנחה קטנה — שעה 9 וחצי מתוך 12 שעות הלכתיות. זמן מנחה בזריזות — עדיף להתפלל מנחה כאן.',
    primary: false,
    group: 'אמצע היום',
  },
  {
    key: 'plagHamincha',
    label: 'פלג המנחה',
    method: 'שעה 10.75 הלכתית',
    tooltip: 'פלג המנחה — שעה 10 ורבע מתוך 12 שעות הלכתיות לפני שקיעה. יש נוהגים להתפלל ערבית ולקבל שבת מפלג המנחה (שיטת ר"ת).',
    primary: false,
    group: 'אמצע היום',
  },
  // ─── ערב ──────────────────────────────────────────────────────────────────
  {
    key: 'sunset',
    label: 'שקיעת החמה',
    method: 'שקיעה',
    tooltip: 'שקיעת החמה — הרגע שגלגל החמה שוקע מתחת לאופק. תחילת בין השמשות. לכתחילה יש לסיים שבת/יו"ט לאחר צאת כוכבים.',
    primary: true,
    group: 'ערב',
  },
  {
    key: 'tzeit85deg',
    label: 'צאת כוכבים 8.5°',
    method: '8.5° מתחת לאופק',
    tooltip: 'צאת כוכבים לשיטת הגר"א ומחבר השו"ע — 8.5° מתחת לאופק. שיטה מקובלת לצאת שבת, יום טוב וצום.',
    primary: true,
    group: 'ערב',
  },
  {
    key: 'tzeit7083deg',
    label: 'צאת כוכבים 7° — ר"ת',
    method: '7.083° מתחת לאופק',
    tooltip: 'צאת כוכבים לשיטת רבינו תם — 7.083° (~72 דקות זמניות בבבל). שיטה מחמירה יותר, מקובלת בקהילות אשכנז.',
    primary: false,
    group: 'ערב',
  },
  {
    key: 'tzeit42min',
    label: "צאת כוכבים 42 דק'",
    method: '42 דקות אחרי שקיעה',
    tooltip: "צאת כוכבים 42 דקות אחרי שקיעת החמה — לפי מנהג מסוים.",
    primary: false,
    group: 'ערב',
  },
  {
    key: 'tzeit50min',
    label: "צאת כוכבים 50 דק'",
    method: '50 דקות אחרי שקיעה',
    tooltip: "צאת כוכבים 50 דקות אחרי שקיעת החמה.",
    primary: false,
    group: 'ערב',
  },
  {
    key: 'tzeit72min',
    label: "צאת כוכבים 72 דק'",
    method: '72 דקות אחרי שקיעה',
    tooltip: "צאת כוכבים 72 דקות אחרי שקיעה לשיטת רבינו תם — בדקות קבועות (לא זמניות).",
    primary: false,
    group: 'ערב',
  },
  {
    key: 'chatzotNight',
    label: 'חצות הלילה',
    method: 'אמצע הלילה ההלכתי',
    tooltip: 'חצות הלילה — אמצע הזמן שבין שקיעת החמה לנץ החמה. זמן תיקון חצות, תחילת זמן עלינו לשבח, ותחילת שמירת הבוקר.',
    primary: false,
    group: 'ערב',
  },
  // ─── זמני פסח (י"ד ניסן בלבד) ────────────────────────────────────────────
  {
    key: 'sofZmanAchilatChametz',
    label: 'סוף זמן אכילת חמץ — גר"א',
    method: 'גר"א — שעה 4 (= סוף זמן תפילה)',
    tooltip: 'סוף זמן אכילת חמץ לשיטת הגר"א — שעה 4 מתוך 12 שעות הלכתיות מנץ החמה (= סוף זמן תפילה). לאחר זמן זה אסור לאכול חמץ.',
    primary: true,
    group: 'זמני פסח',
    showOnlyWhen: { hebrewDay: 14, hebrewMonth: 1 },
  },
  {
    key: 'sofZmanBiurChametz',
    label: 'סוף זמן ביעור חמץ — גר"א',
    method: 'גר"א — שעה 5 (אמצע בין תפילה לחצות)',
    tooltip: 'סוף זמן ביעור (שריפת) חמץ לשיטת הגר"א — שעה 5 מתוך 12 שעות הלכתיות. מחושב כאמצע בין סוף תפילה גר"א לחצות.',
    primary: true,
    group: 'זמני פסח',
    showOnlyWhen: { hebrewDay: 14, hebrewMonth: 1 },
  },
  {
    key: 'sofZmanAchilatChametzMGA',
    label: 'סוף זמן אכילת חמץ — מג"א (72 במע׳)',
    method: 'מג"א — שעה 4 (= סוף תפילה מג"א 16.1°)',
    tooltip: 'סוף זמן אכילת חמץ לשיטת המג"א — שעה 4 מעלות השחר 16.1° (= סוף זמן תפילה מג"א). שיטה מחמירה יותר.',
    primary: true,
    group: 'זמני פסח',
    showOnlyWhen: { hebrewDay: 14, hebrewMonth: 1 },
  },
  {
    key: 'sofZmanBiurChametzMGA',
    label: 'סוף זמן ביעור חמץ — מג"א (72 במע׳)',
    method: 'מג"א — שעה 5 (אמצע בין תפילה מג"א לחצות)',
    tooltip: 'סוף זמן ביעור חמץ לשיטת המג"א — שעה 5 מעלות השחר 16.1°. מחושב כאמצע בין סוף תפילה מג"א 16.1° לחצות.',
    primary: true,
    group: 'זמני פסח',
    showOnlyWhen: { hebrewDay: 14, hebrewMonth: 1 },
  },
];

/** מיפוי day* ← direct — בשימוש ב-PrayerListStep (וידג׳ט תפילות) */
export const DAY_KEY_MAP = {
  dayAlot:                     'alotHaShachar',
  dayNetz:                     'netzHachama',
  daySofZmanShma:              'sofZmanShma',
  daySofZmanShmaMGA:            'sofZmanShmaMGA',
  daySofZmanShmaMGA16Point1:    'sofZmanShmaMGA16Point1',
  daySofZmanShmaMGA19Point8:    'sofZmanShmaMGA19Point8',
  daySofZmanTfilla:             'sofZmanTfilla',
  daySofZmanTfillaMGA:          'sofZmanTfillaMGA',
  daySofZmanTfillaMGA16Point1:  'sofZmanTfillaMGA16Point1',
  daySofZmanTfillaMGA19Point8:  'sofZmanTfillaMGA19Point8',
  dayChatzot:                  'chatzot',
  dayMinchaGedola:             'minchaGedola',
  dayMinchaKetana:             'minchaKetana',
  dayPlagHamincha:             'plagHamincha',
  dayChatzotNight:             'chatzotNight',
  daySunset:                   'sunset',
  dayTzeit85:                  'tzeit85deg',
  dayTzeit7083:                'tzeit7083deg',
  dayTzeit42:                  'tzeit42min',
  dayTzeit50:                  'tzeit50min',
  dayTzeit72:                  'tzeit72min',
  daySofZmanAchilatChametz:    'sofZmanAchilatChametz',
  daySofZmanBiurChametz:       'sofZmanBiurChametz',
  daySofZmanAchilatChametzMGA: 'sofZmanAchilatChametzMGA',
  daySofZmanBiurChametzMGA:    'sofZmanBiurChametzMGA',
};

/** מיפוי הפוך — direct ← day* */
export const DIRECT_TO_DAY_MAP = Object.fromEntries(
  Object.entries(DAY_KEY_MAP).map(([dayKey, directKey]) => [directKey, dayKey])
);

/** קבל תווית עברית לכל מפתח (direct או day*) */
export const getZmanLabel = (key) => {
  const directKey = DAY_KEY_MAP[key] ?? key;
  return ZMAN_DEFINITIONS.find(d => d.key === directKey)?.label ?? key;
};

/** סדר קבוצות לתצוגה */
export const GROUP_ORDER = ['בוקר', 'סוף זמן שמע', 'סוף זמן תפילה', 'אמצע היום', 'ערב', 'זמני פסח'];
